/**
 * 指定されたリストの画像URLのリソースを解放する
 * @param urlList URLリスト
 * @returns なし
 */
export const revokeObjectUrl = (urlList: string[]) => {
  urlList.forEach(url => {
    if (url !== undefined) {
      URL.revokeObjectURL(url)
    }
  })
}

/**
 * データURIからHTMLImageElementを作成する
 * @param dataUri 対象画像のデータURI
 * @returns HTMLImageElement
 */
export const createImageElement = (dataUri: string): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = reject
    img.src = dataUri
  })
}
